import React from 'react';
import { SVGProps } from './types';

const ArrowLeft = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <g clipPath="url(#clip0_485_30816)">
        <path
          stroke="currentColor"
          d="M13.333 8H2.963M6 11.333L2.667 8 6 4.667"
        />
      </g>
      <defs>
        <clipPath id="clip0_485_30816">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ArrowLeft };
